// Generated by ReScript, PLEASE EDIT WITH CARE


var ga_title_home = "Home Page";

var ga_path_home = "/";

var ga_title_seo_pillar = "Services Pillar";

var ga_path_seo_pillar = "/services";

var ga_title_privacy_policy = "Privacy Policy";

var ga_path_privacy_policy = "/privacy-policy";

var ga_title_spot_faq = "Spot FAQs";

var ga_path_spot_faq = "/spot-faq";

var ga_title_terms_of_service = "Terms of Service";

var ga_path_terms_of_service = "/terms-of-service";

var ga_title_support = "Support";

var ga_path_support = "/support";

var ga_title_about_us = "About Us";

var ga_path_about_us = "/about-us";

var ga_path_city_page_prefix = "/rent-mini-trucks-in-";

var ga_title_city_page_prefix = "City Page - ";

var ga_path_trucks_prefix = "/rent-mini-trucks-in-";

var ga_title_trucks_prefix = "City Page - ";

var ga_path_trucks_inventory_prefix = "/rent-mini-trucks-in-";

var ga_title_trucks_inventory_prefix = "City Page Inventory - ";

var ga_title_fare_estimate_result = "Fare Estimate Result";

var ga_path_fare_estimate_result = "/fare_estimate_mob";

var ga_title_partners = "Partners";

var ga_path_partners = "/partners";

var ga_title_404 = "404 Page";

var ga_title_bike_parcel_keyword_prefix = "Bike Parcel - ";

var ga_path_bike_parcel_keyword_prefix = "/bike-parcel-delivery-";

var ga_header_event_prefix = "Header";

var ga_footer_event_prefix = "Footer";

var ga_api_doc_learn_more_click = "Api Doc Learn More Click";

export {
  ga_title_home ,
  ga_path_home ,
  ga_title_seo_pillar ,
  ga_path_seo_pillar ,
  ga_title_privacy_policy ,
  ga_path_privacy_policy ,
  ga_title_spot_faq ,
  ga_path_spot_faq ,
  ga_title_terms_of_service ,
  ga_path_terms_of_service ,
  ga_title_support ,
  ga_path_support ,
  ga_title_about_us ,
  ga_path_about_us ,
  ga_path_city_page_prefix ,
  ga_title_city_page_prefix ,
  ga_path_trucks_prefix ,
  ga_title_trucks_prefix ,
  ga_path_trucks_inventory_prefix ,
  ga_title_trucks_inventory_prefix ,
  ga_title_fare_estimate_result ,
  ga_path_fare_estimate_result ,
  ga_title_partners ,
  ga_path_partners ,
  ga_title_404 ,
  ga_title_bike_parcel_keyword_prefix ,
  ga_path_bike_parcel_keyword_prefix ,
  ga_header_event_prefix ,
  ga_footer_event_prefix ,
  ga_api_doc_learn_more_click ,
}
/* No side effect */
